import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Container,
  Col,
  Row
} from 'reactstrap';

import { API, BASE_URL, POLICY_URL } from 'CONST';
import { GET_MOVIMIENTO_LINEA } from 'redux-store/constants/action-types';
import { cleanData, getData } from 'redux-store/actions/index';
import BaseModal from './UI/BaseModal';

function mapDispatchToProps(dispatch) {
  return {
    getCumulo: client => dispatch(getData(client)),
    resetData: client => dispatch(cleanData(client)),
  };
}

class DetalleUso extends Component {
  componentDidMount() {
    const { getCumulo, id, resetData } = this.props;
    resetData();
    getCumulo({
      url: `${BASE_URL}${API.movimientos}${id}/`,
      name: 'linea',
      type: GET_MOVIMIENTO_LINEA,
    });
  }

  render() {
    const { handleModal, modalOpen, detail } = this.props;
    return (
      <BaseModal
        handleModal={handleModal}
        link={detail ? `${POLICY_URL}guarantee/policies/edit/${detail.garantia.id}` : POLICY_URL}
        modalOpen={modalOpen}
        title="Detalle movimiento"
        type="modal-lg"
      >
        <Container className="uso-body">
          <Row>
            <Col className="form-block">
              <div className="label">
                Código de póliza
              </div>
              <div className="value">
                {detail ? detail.garantia.base.nemotecnico : '-'}
              </div>
            </Col>
            <Col className="form-block">
              <div className="label">
                Tipo
              </div>
              <div className="value">
                {detail ? detail.garantia.base.producto.descripcion : '-'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="form-block">
              <div className="label">
                Afianzado
              </div>
              <div className="value">
                {detail ? `${detail.garantia.afianzado.rut} - ${detail.garantia.afianzado.nombre}` : '-'}
              </div>
            </Col>
            <Col className="form-block">
              <div className="label">
                Asegurado
              </div>
              <div className="value">
                {detail ? `${detail.garantia.base.asegurado.rut} - ${detail.garantia.base.asegurado.nombre}` : '-'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="form-block">
              <div className="label">
                Moneda
              </div>
              <div className="value">
                {detail ? detail.garantia.base.moneda_asegurada.descripcion : '-'}
              </div>
            </Col>
            <Col className="form-block">
              <div className="label">
                Monto Garantizado
              </div>
              <div className="value">
                {detail ? detail.garantia.balance_cobertura_amt : '-'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="form-block">
              <div className="label">
                Prima
              </div>
              <div className="value">
                {detail ? detail.garantia.balance_prima_neta_amt : '-'}
              </div>
            </Col>
            <Col className="form-block">
              <div className="label">
                Emisión
              </div>
              <div className="value">
                {detail ? detail.garantia.emision : '-'}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="form-block">
              <div className="label">
                Inicio Vigencia
              </div>
              <div className="value">
                {detail ? detail.garantia.inicio_vigencia : '-'}
              </div>
            </Col>
            <Col className="form-block">
              <div className="label">
                Fin Vigencia
              </div>
              <div className="value">
                {detail ? detail.garantia.termino_vigencia : '-'}
              </div>
            </Col>
          </Row>
        </Container>
        <div className="uso-button-container d-flex justify-content-end">
          <Button
            className="form-button"
            onClick={handleModal}
          >
            Aceptar
          </Button>
        </div>
      </BaseModal>
    )
  }
}

const mapStateToProps = state => ({ detail: state.clients.lineDetail });

DetalleUso.propTypes = {
  detail: PropTypes.shape({
    garantia: PropTypes.shape({
      afianzado: PropTypes.shape({
        nombre: PropTypes.string,
        rut: PropTypes.string,
      }),
      balance_cobertura_amt: PropTypes.number,
      balance_prima_neta_amt: PropTypes.number,
      base: PropTypes.shape({
        asegurado: PropTypes.shape({
          nombre: PropTypes.string,
          rut: PropTypes.string,
        }),
        nemotecnico: PropTypes.string,
        moneda_asegurada: PropTypes.shape({
          descripcion: PropTypes.string,
        }),
        producto: PropTypes.shape({
          descripcion: PropTypes.string,
        }),
      }),
      emision: PropTypes.string,
      id: PropTypes.number,
      inicio_vigencia: PropTypes.string,
      termino_vigencia: PropTypes.string,
    }),
  }),
  getCumulo: PropTypes.func.isRequired,
  handleModal: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  resetData: PropTypes.func.isRequired,
};

DetalleUso.defaultProps = {
  detail: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetalleUso);


